<template>
  <v-container>
    <v-progress-linear
      v-if="requestLoads"
      indeterminate
      color="primary"
      absolute
      top
    ></v-progress-linear>
    <div
      class="
        d-flex
        flex-lg-row flex-column
        justify-lg-space-between
        align-lg-center align-start
        justify-center
      "
    >
      <h1 class="pt-3 pb-5">
        {{
          activeTerminal == ""
            ? "Sessions Library"
            : "Sessions Library - " + activeTerminal
        }}
      </h1>
      <div style="max-width: 200px; width: 100%;" class="mb-5 mb-lg-0">
        <v-select
          v-model="filters.sales"
          :items="[
            { name: 'All', value: 'all' },
            { name: 'Sale', value: 'notnull' },
            { name: 'No sale', value: 'null' },
          ]"
          item-text="name"
          item-value="value"
          outlined
          dense
          hide-details
        ></v-select>
      </div>
    </div>
    <v-list dense>
      <v-list-item v-if="videos.length < 1 && !requestLoads">
        <v-list-item-content>
          <v-list-item-title align="center">No data</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <VideoCard
        @removeVideo="removeVideo"
        @openVideo="openVideo"
        v-for="(video, index) in videos"
        :received="video"
        :key="index"
        :index="index"
      />
    </v-list>
    <VideoDialog
      @toggleDialog="toggleDialog"
      :dialog="dialog"
      :received="videoData"
      v-if="dialog"
    />
  </v-container>
</template>

<script>
import VideoCard from "../components/VideoCard.vue";
import VideoDialog from "../components/VideoDialog.vue";

import {mapState} from "vuex";

export default {
  name: "Video",
  components: {
    VideoCard,
    VideoDialog,
  },
  data: () => ({
    videos: [],
    dialog: false,
    videoData: {
      name: "",
      video: "",
    },
    page: 0,
    hasNext: false,
    videoLoading: true,
    requestLoads: false,
    filters: {
      sales: "all",
    },
  }),
  computed: {
    ...mapState("terminals", ["activeTerminal"]),
  },
  watch: {
    activeTerminal() {
      this.videos = [];
      this.page = 0;
      window.scrollTo(0, 0);
      this.receiveVideos();
    },
    "filters.sales"() {
      this.videos = [];
      this.page = 0;
      window.scrollTo(0, 0);
      this.receiveVideos();
    }
  },
  methods: {
    openVideo(data) {
      this.videoData.name = data.name;
      this.videoData.video = data.video;

      this.toggleDialog();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    receiveVideos() {
      this.requestLoads = true;
      this.$http
        .get(`rest/videos`, {
          params: { 
            page: this.page, 
            terminal: this.activeTerminal,
            sale: this.filters.sales
          },
        })
        .then((resp) => {
          this.requestLoads = false;
          if (resp.data.videos) {
            this.videos.push.apply(this.videos, resp.data.videos);
            this.hasNext = resp.data.hasNext;
          }
        });
    },
    removeVideo(id) {
      const elem = this.videos.find((n) => n._id == id);
      const index = this.videos.indexOf(elem);
      this.videos.splice(index, 1);
    },
    scroll() {
      const body = document.body;
      if (
        body.scrollHeight - window.scrollY < window.innerHeight + 100 &&
        !this.requestLoads &&
        this.hasNext
      ) {
        this.page++;
        this.receiveVideos();
      }
    },
  },
  mounted() {
    this.receiveVideos();
    window.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
};
</script>
